/* eslint-disable global-require */

export default {
  homescapes: [
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/ja/preview-01.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/ja/preview-02.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/ja/preview-03.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/ja/preview-04.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/ja/preview-05.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/ja/preview-06.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/ja/preview-07.webp'),
    },
  ],
  township: [
    {
      type: 'image',
      link: require('@/assets/images/township/preview/ja/preview-01.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/township/preview/ja/preview-02.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/township/preview/ja/preview-03.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/township/preview/ja/preview-04.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/township/preview/ja/preview-05.webp'),
    },
  ],
};
